module.exports = __webpack_public_path__ + "img/landkreis_logo.01351cb.png";